import React, { useEffect, useRef, useState } from "react";
import { Box, FormControl, Grid, Paper, TextField, Typography, IconButton, MenuItem, Select, InputLabel, Card, CardContent, Button } from "@mui/material";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import RichTextEditor from "../../components/reusableComponents/ResuableRichTextEditor";
import { useHistory } from "react-router-dom";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import ApiService from "../../_services/ApiService";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import ReusableMultiComponent from "../../components/reusableComponents/ReusableMultiComponent";
import { DatePicker, LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ReusableCheckboxGroup from "../../components/reusableComponents/reusableCheckboxGroup ";
import { eligibleRequirement, featuredRequirement } from "../../_helpers/reusablefunctions/eligibleRequirement";
import ReusableImageComponent from "../../components/reusableComponents/ReusableImageComponent";
import FirebaseImageStore from "../../_helpers/reusablefunctions/firebaseImageStore";
import { validateImageFile } from "../../_helpers/reusablefunctions/validateImageFile";
import { useParams, useLocation } from "react-router-dom";
import ReusableDateInput from "../../components/reusableComponents/ReusableDateInput";
import ReusableNumberComponent from '../../components/reusableComponents/ReusableNumberComponent'
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import { useLiveFieldErrors } from "../../hooks/useLiveFieldErrors";
import { scrollToFirstError } from "../../_helpers/reusablefunctions/scrollToFirstError";
import { hasAnyValue } from "../../_helpers/reusablefunctions/formHasData";
import ConfirmationDialog from "../../components/reusableComponents/conformationDialogBox";

const marginBottom = "20px"

// Content Format Options
const contentFormatOptions = [
    { value: "Reel", label: "Reel" },
    { value: "Story", label: "Story" },
    { value: "Post", label: "Post" },
    { value: "Static Post", label: "Static Post" },
    { value: "UGC", label: "UGC" },
    { value: "Blog", label: "Blog" },
    { value: "Live Session", label: "Live Session" },
    { value: "Video", label: "Video" },
    { value: "Testimonial", label: "Testimonial" },
    { value: "Photos", label: "Photos" },
];


const locationWorkplaceOptions = [
    { value: "in-person", label: "In-person" },
    { value: "hybrid", label: "Hybrid" },
    { value: "remote", label: "Remote" },
];

const paymentTypeOptions = [
    { value: "Paid", label: "Paid" },
    { value: "Barter", label: "Barter" },
    { value: "Affiliate", label: "Affiliate" },
    { value: "Commission", label: "Commission" },
    { value: "Hybrid", label: "Hybrid" },
];

const paymentTermsOptions = [
    { value: "Advance", label: "Advance" },
    { value: "Milestone", label: "Milestone" },
    { value: "On Approval", label: "On Approval" },
];

const targetGenderOptions = [
    { value: "Any", label: "Any" },
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
];

export default function CreateGigManagement(params) {
    const { successSnack, errorSnack } = useSnackDispatcher();
    const history = useHistory();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData;
    const userData = useSelector((state) => state.userData.userData);
    const [GigWorkType, setGigWorkType] = useState([]);
    const [GigWorkTypeSelection, setGigWorkTypeSelection] = useState([]);
    const [Requirements, setRequirements] = useState("");
    const [AboutGigWork, setAboutGigWork] = useState("");
    const [RewardAmount, setRewardAmount] = useState("");
    const [FAQ, setFAQ] = useState("");
    const [Completethetask, setCompletethetask] = useState("");
    const [Title, setTitle] = useState("");
    const [Location, setLocation] = useState("");
    const [DeadLineDate, setDeadLineDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [confirmLeaveOpen, setConfirmLeaveOpen] = useState(false);
    const lastValidatedDraft = useRef(null); // null until the first submit attempt
    const [loader, setLoader] = useState(false);
    const [eligibleRequirementSelection, setEligibleRequirementSelection] = useState([]);
    const requirement = eligibleRequirement();
    const featureList = featuredRequirement();
    const [selectedFile, setSelectedFile] = useState(null);
    const [gigImageURL, setGigImageURL] = useState(null);
    const [eligibleFeaturedSelection, setEligibleFeaturedSelection] = useState([]);
    const [isDraft, setIsDraft] = useState(null);
    const [contentDeadlineDate, setContentDeadlineDate] = useState(null);
    const [postDeadlineDate, setPostDeadlineDate] = useState(null);
    const [platforms, setPlatforms] = useState([]);
    const [platformOptions, setPlatformOptions] = useState([]);
    const [revisionsAllowed, setRevisionsAllowed] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [paymentTerms, setPaymentTerms] = useState("");
    const [locationWorkplace, setLocationWorkplace] = useState("");
    const [industryCategory, setIndustryCategory] = useState([]);
    const [industryCategoryOptions, setIndustryCategoryOptions] = useState([]);
    const [targetAgeMin, setTargetAgeMin] = useState("");
    const [targetAgeMax, setTargetAgeMax] = useState("");
    const [targetInterests, setTargetInterests] = useState("");
    const [targetGender, setTargetGender] = useState("Any");
    const [createdGigId, setCreatedGigId] = useState(null);

    const [sections, setSections] = useState([{ format: null, quantities: "" }]);
    const [formErrors, setFormErrors] = useState({});
    const [remark, setRemark] = useState("");
    const [commission, setCommission] = useState("");
    const [referenceLinks, setReferenceLinks] = useState([{ link: '' }]);

    const { uploadImages } = FirebaseImageStore({
        selectedFile,
        selectedFiles: [],
        functionCall: ({ bannerURL }, draft) =>
            submitOfferDetails({ downloadURL: bannerURL, draft }),
    });

    useEffect(() => {
        ApiService.get('platform').then((res) => {
            const platforms = res?.data?.results || res?.data?.data || [];
            setPlatformOptions(platforms);
        }).catch(error => {
            console.log("platform fetch error:", error);
        });
    }, []);

    useEffect(() => {
        ApiService.get('offers_eligible').then((res) => {
            if (res?.status === 200 || res?.status === 201) {
                setIndustryCategoryOptions(res?.data?.data || []);
            }
        }).catch(error => {
            console.log("industry category fetch error:", error);
        });
    }, []);

    useEffect(() => {
        ApiService.get('gigsType').then((res) => {
            if (res?.status === 200 || res?.status === 201) {
                setGigWorkTypeSelection(res?.data?.data);
            }
        }).catch(error => {
            console.log("event:", error);
        });
    }, []);



    // ---------------- edit gig start ---------------
    const { id } = useParams();
    const isEditMode = Boolean(id);
    const gigId = id;

    useEffect(() => {
        if (isEditMode && locationEventDetail) {
            const data = locationEventDetail;
            console.debug("creategig: data", { data });
            setGigImageURL(data?.GIGworkImage || data?.Featured_Banner_URL || data?.Featured_Banner || null);
            setTitle(data?.Title || '');
            setLocation(data?.Location || '');
            setAboutGigWork(data?.AboutGigWork || '');
            setRewardAmount(data?.RewardAmount || '');
            setDeadLineDate(data?.DeadLineDate || '');
            setEligibleRequirementSelection(
                requirement.filter((item) => data[item?.Value])
            );
            setEligibleFeaturedSelection(
                featureList.filter((item) => data[item?.Value])
            );
            setFAQ(data?.FAQ || '');
            setRequirements(data?.Requirements || '');
            setCompletethetask(data?.Completethetask || '');

            // New fields
            setContentDeadlineDate(data?.contentDeadlineDate || null);
            setPostDeadlineDate(data?.postDeadlineDate || null);
            setRevisionsAllowed(data?.revisions_allowed || '');
            setPaymentType(data?.payment_type || '');
            setPaymentTerms(data?.payment_terms || '');
            setLocationWorkplace(data?.location_workplace || '');
            setTargetAgeMin(data?.target_age_min || '');
            setTargetAgeMax(data?.target_age_max || '');
            setTargetInterests(data?.target_interests || '');
            setTargetGender(data?.target_gender || 'Any');
            setRemark(data?.remark || '');
            setCommission(data?.commission || "");

            if (data?.GigWorkType?.length) {
                const matchedUsers = GigWorkTypeSelection.filter((item) =>
                    data.GigWorkType.some((ot) => ot.id === item.id)
                );
                setGigWorkType(matchedUsers);
            }

            if (data?.platforms?.length) {
                const matchedPlatforms = platformOptions.filter((item) =>
                    data.platforms.some((p) => p.id === item.id)
                );
                setPlatforms(matchedPlatforms);
            }

            if (data?.industry_category?.length) {
                const matchedCategories = industryCategoryOptions.filter((item) =>
                    data.industry_category.some((ic) => ic.id === item.id)
                );
                setIndustryCategory(matchedCategories);
            }

            if (data?.content_requirements?.length) {
                const mappedSections = data.content_requirements.map(cr => ({
                    id: cr.id,
                    format: cr.format ? { label: cr.format, value: cr.format } : null,
                    quantities: cr.quantities,
                    __original: {
                        format: cr.format,
                        quantities: cr.quantities
                    }
                }));
                setSections(mappedSections);
            }

            if (data?.reference_links?.length) {
                const mappedLinks = data.reference_links.map(rl => ({
                    id: rl.id,
                    link: rl.link,
                    __original: rl.link
                }));
                setReferenceLinks(mappedLinks);
            }


        }
    }, [id, GigWorkTypeSelection, platformOptions, industryCategoryOptions, isEditMode, locationEventDetail]);

    // ---------------- edit gig end ---------------
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            validateImageFile(file, 412, 274, (errorMsg) => {
                if (errorMsg) {
                    setErrors(prev => ({ ...prev, image: errorMsg }));
                    setSelectedFile(null);
                } else {
                    setSelectedFile(file);
                    setErrors(prev => ({ ...prev, image: null }));
                }
            });
        }
    };

    const handleReferenceLinkChange = (index, value) => {
        setReferenceLinks(prev => {
            const copy = [...prev];
            copy[index] = {
                ...copy[index],
                link: value
            };
            return copy;
        });
        clearError("reference_links");
    };


    const addReferenceLink = () => {
        setReferenceLinks(prev => [...prev, { link: '' }]);
    };

    const removeReferenceLink = (index) => {
        setReferenceLinks(prev => prev.filter((_, i) => i !== index));
    };


    // ---------- Content Requirements Handlers ----------

    const handleFormatChange = (index, selectedOption) => {
        if (!selectedOption || !selectedOption.label) return;

        const isDuplicate = sections.some((section, idx) =>
            idx !== index && section.format?.label === selectedOption.label
        );

        if (isDuplicate) {
            setFormErrors((prev) => {
                const updated = [...(prev.sections || [])];
                if (!updated[index]) updated[index] = {};
                updated[index].format = "This format is already selected.";
                return { ...prev, sections: updated };
            });
            return;
        }

        setSections(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], format: selectedOption };
            return copy;
        });

        clearSectionErrors(index, "format");
        clearError("content_requirements");
    };

    const handleNumberChange = (index, value) => {
        setSections(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], quantities: value };
            return copy;
        });

        clearSectionErrors(index, "quantities");
        clearError("content_requirements");
    };


    const handleBlur = async (index) => {
        const section = sections[index];
        if (!section?.id) return;

        const hasChanged =
            section.format?.label !== section.__original.format ||
            Number(section.quantities) !== Number(section.__original.quantities);

        if (!hasChanged) return;

        await ApiService.put(
            "content_requirements",
            {
                format: section.format.label,
                quantities: section.quantities
            },
            { id: section.id }
        );

        setSections(prev =>
            prev.map((s, i) =>
                i === index
                    ? {
                        ...s,
                        __original: {
                            format: s.format.label,
                            quantities: s.quantities
                        }
                    }
                    : s
            )
        );
    };


    const handleDeleteSection = (indexToRemove) => {
        // Simply remove from local sections state; do not call any API
        setSections(prev => prev.filter((_, index) => index !== indexToRemove));
    };


    const handleAddSection = () => {
        if (sections.length < 5) {
            setSections([...sections, { format: null, quantities: "" }]);
        }
    };

    const clearSectionErrors = (index, field) => {
        setFormErrors((prev) => {
            if (!prev.sections || !prev.sections[index]) return prev;
            const updated = [...prev.sections];
            if (updated[index]) {
                delete updated[index][field];
                if (Object.keys(updated[index]).length === 0) {
                    updated[index] = undefined;
                }
            }
            return { ...prev, sections: updated };
        });
    };

    const isValidReferenceLink = (url = "") => {
        const trimmed = url.trim();

        const patterns = [
            /^https?:\/\/(www\.)?drive\.google\.com\/.+/i,
            /^https?:\/\/(www\.)?instagram\.com\/.+/i,
            /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\/.+/i,
            /^https?:\/\/(www\.)?facebook\.com\/.+/i,
        ];

        return patterns.some((pattern) => pattern.test(trimmed));
    };

    const getPlainTextLength = (html = "") => {
        return html.replace(/<[^>]*>/g, "").trim().length;
    };

    // --------------- validation handler ----------
    function computeValidation(draft) {
        let errors = {};
        let isValid = true;

        if (Title.trim() === '') {
            errors.Title = "Gig title is required.";
            isValid = false;
        }
        if (Location === '') {
            errors.Location = "Location is required.";
            isValid = false;
        }
        const filledSections = sections.filter(s => s.format?.label || (s.quantities && s.quantities !== ""));

        const hasFormat = filledSections.some(s => s.format?.label);
        const hasQuantity = filledSections.some(s => s.quantities && s.quantities !== "" && Number(s.quantities) > 0);

        const hasCompleteRow = filledSections.some(
            s => s.format?.label && s.quantities && s.quantities !== "" && Number(s.quantities) > 0
        );

        const hasQuantityWithoutFormat = filledSections.some(
            s => (s.quantities && s.quantities !== "" && Number(s.quantities) > 0) && !s.format
        );

        const hasFormatWithoutQuantity = filledSections.some(
            s => s.format && (!s.quantities || s.quantities === "" || Number(s.quantities) <= 0)
        );

        if (filledSections.length > 0) {
            if (!hasFormat) {
                errors.content_requirements = "At least one format is required.";
                isValid = false;
            }
            else if (!hasQuantity) {
                errors.content_requirements = "At least one quantity is required.";
                isValid = false;
            }
            else if (hasFormatWithoutQuantity) {
                errors.content_requirements = "Quantity is required for selected format.";
                isValid = false;
            }
            else if (hasQuantityWithoutFormat) {
                errors.content_requirements = "Format is required for entered quantity.";
                isValid = false;
            }
            else if (!hasCompleteRow) {
                errors.content_requirements = "Please complete at least one content requirement.";
                isValid = false;
            }
        } else {
            errors.content_requirements = "At least one format and quantity is required.";
            isValid = false;
        }

        const validReferences = referenceLinks.filter(
            r => r.link && r.link.trim() !== ''
        );

        if (!validReferences.length) {
            errors.reference_links = "At least one reference link is required.";
            isValid = false;
        } else {
            const invalidLink = validReferences.find(
                r => !isValidReferenceLink(r.link)
            );

            if (invalidLink) {
                errors.reference_links =
                    "Only Google Drive, Instagram, YouTube, or Facebook links are allowed.";
                isValid = false;
            }
        }

        if (!draft) {
            if (RewardAmount.trim() === '') {
                errors.RewardAmount = "Reward amount is required.";
                isValid = false;
            }
            if (!AboutGigWork || AboutGigWork.trim() === '') {
                errors.AboutGigWork = "Gig description is required.";
                isValid = false;
            } else if (AboutGigWork.length > 800) {
                errors.AboutGigWork = "Description cannot exceed 800 characters.";
                isValid = false;
            }
            if (!contentDeadlineDate) {
                errors.contentDeadlineDate = "Content deadline date is required.";
                isValid = false;
            }
            if (!postDeadlineDate) {
                errors.postDeadlineDate = "Post deadline date is required.";
                isValid = false;
            }
            // if (!selectedFile && !gigImageURL) {
            //     errors.image = "Please upload the banner.";
            //     isValid = false;
            // }
            if (!GigWorkType.length) {
                errors.GigWorkType = "Target audience is required.";
                isValid = false;
            }
            if (!eligibleRequirementSelection.length) {
                errors.eligibleRequirementSelection = "Check atleast one.";
                isValid = false;
            }
            if (!DeadLineDate) {
                errors.DeadLineDate = "Deadline date is required.";
                isValid = false;
            }
            if (!locationWorkplace) {
                errors.locationWorkplace = "Location workplace is required.";
                isValid = false;
            }
            if (getPlainTextLength(Requirements) > 800) {
                errors.Requirements = "Requirements cannot exceed 800 characters.";
                isValid = false;
            }
            if (getPlainTextLength(Completethetask) > 800) {
                errors.Completethetask = "Task list cannot exceed 800 characters.";
                isValid = false;
            }
            if (getPlainTextLength(FAQ) > 800) {
                errors.FAQ = "FAQ cannot exceed 800 characters.";
                isValid = false;
            }
        }

        return { errors, isValid };
    }

    function validationInputs(draft) {
        lastValidatedDraft.current = draft;
        const { errors, isValid } = computeValidation(draft);
        setErrors(errors);
        return isValid;
    }

    // after the first submit attempt, keep each field's error in sync with its value
    useLiveFieldErrors({
        setErrors,
        computeErrors: () =>
            lastValidatedDraft.current === null
                ? null
                : computeValidation(lastValidatedDraft.current).errors,
        managedKeys: [
            'Title', 'Location', 'content_requirements', 'reference_links', 'RewardAmount',
            'AboutGigWork', 'contentDeadlineDate', 'postDeadlineDate', 'GigWorkType',
            'eligibleRequirementSelection', 'DeadLineDate', 'locationWorkplace',
            'Requirements', 'Completethetask', 'FAQ',
        ],
        deps: [
            Title, Location, sections, referenceLinks, RewardAmount,
            AboutGigWork, contentDeadlineDate, postDeadlineDate, GigWorkType,
            eligibleRequirementSelection, DeadLineDate, locationWorkplace,
            Requirements, Completethetask, FAQ,
        ],
    });

    const validateSectionRow = (section, index) => {
        setFormErrors(prev => {
            const updated = [...(prev.sections || [])];
            let rowErrors = {};

            const qty = Number(section.quantities);

            // Format selected, quantity missing
            if (section.format && (section.quantities === "" || section.quantities === undefined)) {
                rowErrors.quantities = "Quantity is required";
            }

            // Quantity <= 0
            else if (section.format && qty <= 0) {
                rowErrors.quantities = "Quantity must be greater than 0";
            }

            // Quantity entered but format missing
            if (section.quantities && !section.format) {
                rowErrors.format = "Format is required";
            }

            updated[index] = Object.keys(rowErrors).length ? rowErrors : undefined;
            return { ...prev, sections: updated };
        });
    };

    const clearError = (field) => {
        setErrors(prev => {
            if (!prev[field]) return prev;
            const copy = { ...prev };
            delete copy[field];
            return copy;
        });
    };




    // ------------- submit handler ---------
    const handleResponse = (res, draft) => {
        if (res.status === 200 || res.status === 201) {
            const gigId = res?.data?.data?.id || res?.data?.id;
            setCreatedGigId(gigId);

            setLoader(false);
            successSnack(draft ? formSnackbar?.profileSuccess?.successMessageDraft : formSnackbar?.profileSuccess?.successMessage);
            navigateAfterSubmit(draft);
        } else {
            const errorData = res?.data || {};
            Object.keys(errorData).forEach(field => {
                let messages = errorData[field];
                if (Array.isArray(messages)) {
                    messages = messages.join(', ');
                } else if (typeof messages === "object" && messages !== null) {
                    messages = JSON.stringify(messages);
                }
                errorSnack(`${field}: ${messages}`);
            });
            setLoader(false);
        }
    };


    const navigateAfterSubmit = (draft) => {
        if (draft) {
            history.push('/gig-management/view-gig-draft');
        } else {
            history.push('/gig-management');
        }
    };

    const handleError = (error) => {
        setLoader(false);
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
    };

    function submitProfile(e, draft) {
        e.preventDefault();

        const isValid = validationInputs(draft);
        if (!isValid) {
            scrollToFirstError();
            return;
        }

        if (!selectedFile) {
            submitOfferDetails({ downloadURL: gigImageURL, draft });
        } else {
            uploadImages(draft);
        }
    }

    function submitOfferDetails({ downloadURL, draft }) {
        const gigWorkType = GigWorkType.map(type => type.id);

        const platformIds = platforms.map(platform => String(platform.id));
        const industryCategoryIds = industryCategory.map(category => String(category.id));

        const content_requirements = sections
            .filter(s => s.format?.label && (s.quantities !== undefined && s.quantities !== null && s.quantities !== ''))
            .map(s => ({
                format: s.format.label,
                quantities: String(s.quantities)
            }));

        const reference_links = referenceLinks
            .filter(r => r.link && r.link.trim() !== '')
            .map(r => ({ link: r.link.trim() }));

        const formattedCommission = commission
            ? (commission.toString().trim().endsWith('%') ? commission.toString().trim() : `${commission.toString().trim()}%`)
            : null;

        let payload = {
            'Title': Title,
            'Requirements': Requirements,
            'AboutGigWork': AboutGigWork,
            'RewardAmount': RewardAmount,
            'FAQ': FAQ,
            'GigWorkType': gigWorkType,
            'Completethetask': Completethetask,
            "DeadLineDate": DeadLineDate ? dayjs(DeadLineDate).format('YYYY-MM-DD') : null,
            'BrandID': userData?.brand,
            ...eligibleFeaturedSelection
                .filter(delivey => delivey?.Value)
                .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            ...eligibleRequirementSelection
                .filter(delivey => delivey?.Value)
                .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            ...featureList.reduce((acc, item) => ({
                ...acc,
                [item.Value]: eligibleFeaturedSelection.some(sel => sel.Value === item.Value)
            }), {}),
            'BrandLogoURL': userData?.avatar_url,
            'BrandName': userData?.brand_name,
            'Featured_Banner_URL': downloadURL,
            'Is_draft': draft,
            'Enable_Brand': true,
            'Location': Location,
            // New fields
            'contentDeadlineDate': contentDeadlineDate ? dayjs(contentDeadlineDate).format('YYYY-MM-DD') : null,
            'postDeadlineDate': postDeadlineDate ? dayjs(postDeadlineDate).format('YYYY-MM-DD') : null,
            'platforms': platformIds,
            'revisions_allowed': revisionsAllowed ? parseInt(revisionsAllowed) : null,
            'payment_type': paymentType,
            'payment_terms': paymentTerms,
            'location_workplace': locationWorkplace,
            'industry_category': industryCategoryIds,
            'target_age_min': targetAgeMin ? parseInt(targetAgeMin) : null,
            'target_age_max': targetAgeMax ? parseInt(targetAgeMax) : null,
            'target_interests': targetInterests,
            'target_gender': targetGender,
            'remark': remark,
            'commission': formattedCommission,
            'content_requirements': content_requirements,
            'reference_links': reference_links,
        };

        console.debug("submitGigs: payload", { payload });

        setIsDraft(draft);
        setLoader(true);
        const request = isEditMode
            ? ApiService.put('gigs_updation', payload, {}, id)
            : ApiService.post('gigscreate', payload);

        request
            .then(res => handleResponse(res, draft))
            .catch(handleError);
    }


    const hasFormData = () => hasAnyValue([
        Title, Location, Requirements, AboutGigWork, RewardAmount, FAQ, Completethetask,
        GigWorkType, DeadLineDate, contentDeadlineDate, postDeadlineDate, platforms,
        revisionsAllowed, paymentType, paymentTerms, locationWorkplace, industryCategory,
        targetAgeMin, targetAgeMax, targetInterests, remark, commission,
        eligibleRequirementSelection, eligibleFeaturedSelection, selectedFile,
        // both start with one blank row, so check for real content instead of length
        sections.some(section => section.format || String(section.quantities ?? '').trim() !== ''),
        referenceLinks.some(reference => String(reference.link ?? '').trim() !== ''),
    ]);

    function backClickHistory(params) {
        if (hasFormData()) {
            setConfirmLeaveOpen(true);
            return;
        }
        history.push('/gig-management');
    }

    const leaveWithoutSaving = () => {
        setConfirmLeaveOpen(false);
        history.push('/gig-management');
    };

    const handleReferenceBlur = async (index) => {
        const ref = referenceLinks[index];
        if (!ref?.id) return;
        if (ref.link === ref.__original) return;

        await ApiService.put(
            "reference_links",
            { link: ref.link },
            { id: ref.id }
        );

        setReferenceLinks(prev =>
            prev.map((r, i) =>
                i === index ? { ...r, __original: r.link } : r
            )
        );
    };

    const ButtonComponentGig = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ReusableButton
                    loader={isDraft && loader}
                    disabled={isDraft != null ? !isDraft : false}
                    variant="outlined"
                    classNames={'gn-actionbtn-outline gn-actionbtn-color '}
                    onClick={(e) => submitProfile(e, true)}
                    children="Save Draft"
                    sx={{ color: '#6D788D', marginRight: '10px' }}
                />
                <ReusableButton
                    loader={!isDraft && loader}
                    disabled={isDraft}
                    classNames={'gn-actionbtn'}
                    variant="outlined"
                    children="Publish gig"
                    sx={{ color: '#6D788D', marginLeft: { xs: 0, sm: 0, md: 0 } }}
                    onClick={(e) => submitProfile(e, false)}
                />
            </Box>
        );
    };

    return (
        <Box p={4}>
            <Box
                display={'flex'}
                alignItems={{ xs: 'none', sm: 'center', md: 'center' }}
                justifyContent={'space-between'}
                sx={{ flexDirection: { xs: 'column', sm: 'row', md: 'row' }, paddingBottom: { xs: '20px', sm: 0, md: 0 } }}
            >
                <ReusableHeadingComponents
                    bacHistory={true}
                    clickHandlerBack={backClickHistory}
                    heading={'Create New Gig'}
                    subHeading={'Effortlessly Create, Manage, and Track Your Gig Opportunities'}
                />
                {ButtonComponentGig()}
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <ReusableCardView
                        title="Upload Banner"
                        Component={
                            <Box>
                                <ReusableImageComponent
                                    selectedFile={selectedFile}
                                    handleFileChange={handleImageChange}
                                    disabled={false}
                                    imageSrc={gigImageURL}
                                    tooltipTitle="Change Cover Image"
                                    imageBannerRatioText='The Offer image must be 412x274 pixels.'
                                    // error={!!errors.image}
                                    // helperText={errors.image}
                                    selectedOptions={eligibleFeaturedSelection}
                                    setSelectedOptions={setEligibleFeaturedSelection}
                                />
                            </Box>
                        }
                    />
                    <Box sx={{ pt: 1 }}>
                        <ReusableCardView
                            title="Eligible Users"
                            Component={
                                <Box px={2} pt={2} pb={1}>
                                    <ReusableMultiComponent
                                        label={'Target audience'}
                                        options={GigWorkTypeSelection}
                                        selectedOptions={GigWorkType}
                                        // setSelectedOptions={setGigWorkType}
                                        setSelectedOptions={(value) => {
                                            setGigWorkType(value);
                                            clearError("GigWorkType");
                                        }}
                                        optionLabel="TypeName"
                                        requireValue={true}
                                        error={!!errors.GigWorkType}
                                        helperText={errors.GigWorkType}
                                    />
                                </Box>
                            }
                            disablepaddingBottom={true}
                        />
                    </Box>

                    {/* Content Requirements Section */}
                    <Box pt={1}>
                        <ReusableCardView
                            title={<>Content Requirements <span style={{ color: '#d32f2f' }}>*</span></>}
                            Component={
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 2, pt: 2, pb: 2 }}>
                                    {sections.map((section, index) => (
                                        <Paper key={index} elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #eee' }}>
                                            <Grid container spacing={2} alignItems="center">
                                                {/* Format */}
                                                <Grid item xs={12} sm={7}>
                                                    <ReusableComponent
                                                        type="select"
                                                        label="Format"
                                                        placeholder="Select format"
                                                        value={section?.format}
                                                        onChange={(value) => handleFormatChange(index, value)}
                                                        onBlur={() => validateSectionRow(section, index)}
                                                        options={contentFormatOptions}
                                                        size="small"
                                                        error={!!formErrors.sections?.[index]?.format || !!errors.content_requirements}
                                                        helperText={formErrors.sections?.[index]?.format || errors.content_requirements}
                                                        fullWidth
                                                    />
                                                </Grid>

                                                {/* Quantities */}
                                                <Grid item xs={9} sm={4} sx={{ pt: "0px !important" }}>
                                                    <ReusableNumberComponent
                                                        value={section.quantities}
                                                        onChange={(value) => handleNumberChange(index, value)}
                                                        onBlur={() => validateSectionRow(section, index)}
                                                        error={!!formErrors.sections?.[index]?.quantities || !!errors.content_requirements}
                                                        helperText={formErrors.sections?.[index]?.quantities || errors.content_requirements}
                                                        fullWidth
                                                    />
                                                </Grid>

                                                {/* Actions: delete (local-only) */}
                                                <Grid item xs={3} sm={1} sx={{ textAlign: 'right' }}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleDeleteSection(index)}
                                                        aria-label={`Delete content requirement ${index + 1}`}
                                                        sx={{ color: 'error.main' }}
                                                    >
                                                        <ReusableMuiIcons name="delete" />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Paper>

                                    ))}


                                    {/* Footer hint / counter */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="caption" color="text.secondary">
                                            {sections.length} / 5 selected
                                        </Typography>

                                        {sections.length < 5 ? (
                                            <Button
                                                size="small"
                                                onClick={handleAddSection}
                                                startIcon={<ReusableMuiIcons name="addbox" />}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                Add more
                                            </Button>
                                        ) : (
                                            <Typography variant="caption" color="text.secondary">
                                                Maximum sections reached
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            }
                            disablepaddingBottom={true}
                        />

                    </Box>

                    {/* Reference Links */}
                    <Box pt={1}>
                        <ReusableCardView
                            title={<>Reference Links <span style={{ color: '#d32f2f' }}>*</span></>}
                            Component={
                                <Box px={2} pt={2} pb={2}>
                                    {referenceLinks.map((item, idx) => (
                                        <Box key={idx} sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1 }}>
                                            <ReusableComponent
                                                type="text"
                                                label={`Reference Link ${idx + 1}`}
                                                value={item.link}
                                                onChange={(val) => handleReferenceLinkChange(idx, val)}
                                                onBlur={() => handleReferenceBlur(idx)}
                                                placeholder={'Drive link or Instagram / Facebook / YouTube URL'}
                                                fullWidth
                                                error={!!errors.reference_links}
                                                helperText={errors.reference_links}
                                            />
                                            <Box>
                                                {referenceLinks.length > 1 ? (
                                                    <IconButton onClick={() => removeReferenceLink(idx)} sx={{ mt: '6px' }}>
                                                        <ReusableMuiIcons name="delete" />
                                                    </IconButton>
                                                ) : null}
                                            </Box>
                                        </Box>
                                    ))}

                                    <Box sx={{ mt: 1 }}>
                                        <Button
                                            onClick={addReferenceLink}
                                            size="small"
                                            startIcon={<ReusableMuiIcons name="addbox" />}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Add more
                                        </Button>
                                    </Box>
                                </Box>
                            }
                        />
                    </Box>

                    {/* Eligibility & Targeting */}
                    <Box sx={{ mt: 0, pt: 1 }}>
                        <ReusableCardView
                            title="Eligibility & Targeting"
                            Component={
                                <Box px={2} pt={2}>
                                    <ReusableCheckboxGroup
                                        title="Requirements"
                                        requireValue={true}
                                        options={[
                                            {
                                                id: 1,
                                                Name: "Youth",
                                                Value: "Enable_Student",
                                            },
                                            {
                                                id: 2,
                                                Name: "Creator",
                                                Value: "Enable_Creator",
                                            },
                                        ]}
                                        selectedOptions={eligibleRequirementSelection}
                                        // setSelectedOptions={setEligibleRequirementSelection}
                                        setSelectedOptions={(value) => {
                                            setEligibleRequirementSelection(value);
                                            clearError("eligibleRequirementSelection");
                                        }}
                                        optionLabel="Name"
                                        selectAllLabel="All Users"
                                        error={!!errors.eligibleRequirementSelection}
                                        helperText={errors.eligibleRequirementSelection}
                                    />
                                </Box>
                            }
                            disablepaddingBottom={true}
                        />
                    </Box>

                    <Box sx={{ mt: 0, pt: 1 }}>
                        <ReusableCardView
                            title="Task list"
                            Component={
                                <Box px={2} pt={2} pb={2}>
                                    <RichTextEditor
                                        value={Completethetask}
                                        // onChange={setCompletethetask}
                                        onChange={(val) => {
                                            setCompletethetask(val);
                                            clearError("Completethetask");
                                        }}
                                        placeholder="Write something..."
                                        minHeight="160px"
                                        helperText={errors.Completethetask}
                                        error={!!errors.Completethetask}
                                    />
                                </Box>
                            }
                        />
                    </Box>
                </Grid>

                {/* Left Section */}
                <Grid item xs={12} md={6}>
                    <ReusableCardView
                        title="Basic Information"
                        Component={
                            <Box px={2} pt={2}>
                                <ReusableComponent
                                    type="text"
                                    label="Gig title"
                                    value={Title}
                                    // onChange={setTitle}
                                    onChange={(val) => {
                                        setTitle(val);
                                        clearError("Title");
                                    }}
                                    error={!!errors.Title}
                                    helperText={errors.Title}
                                    placeholder={'Gig title'}
                                    requireValue={true}
                                    marginSize={marginBottom}
                                />
                                <ReusableComponent
                                    type="text"
                                    label="Location"
                                    value={Location}
                                    // onChange={setLocation}
                                    onChange={(val) => {
                                        setLocation(val);
                                        clearError("Location");
                                    }}
                                    error={!!errors.Location}
                                    helperText={errors.Location}
                                    placeholder={'Location'}
                                    requireValue={true}
                                    marginSize={marginBottom}
                                />
                                <ReusableComponent
                                    type="text"
                                    label="Gig description"
                                    requireValue={true}
                                    rowsCount={5}
                                    multiline={true}
                                    value={AboutGigWork}
                                    // onChange={setAboutGigWork}
                                    onChange={(val) => {
                                        setAboutGigWork(val);
                                        clearError("AboutGigWork");
                                    }}
                                    error={!!errors.AboutGigWork}
                                    helperText={errors.AboutGigWork}
                                    placeholder={'Detailed explanation of the gig'}
                                    marginSize={marginBottom}
                                />
                                <Box display={'flex'} sx={{ flexDirection: 'column', gap: { xs: 2, sm: 2, md: 2 } }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: { xs: 'column', sm: 'column' },
                                            gap: 2,
                                            width: '100%',
                                        }}
                                    >
                                        {/* Payment Type */}
                                        <FormControl fullWidth size="small" sx={{ minWidth: { xs: '100%', sm: 180 } }}>
                                            <InputLabel>Payment Type</InputLabel>
                                            <Select
                                                value={paymentType}
                                                label="Payment Type"
                                                onChange={(e) => setPaymentType(e.target.value)}
                                            >
                                                {paymentTypeOptions.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {/* Gig Amount (flexes to fill available space) */}
                                        <Box sx={{ flex: 1, width: '100%' }}>
                                            <ReusableComponent
                                                type="numeric"
                                                label="Gig amount"
                                                requireValue={true}
                                                value={RewardAmount}
                                                // onChange={setRewardAmount}
                                                onChange={(val) => {
                                                    setRewardAmount(val);
                                                    clearError("RewardAmount");
                                                }}
                                                error={!!errors.RewardAmount}
                                                helperText={errors.RewardAmount}
                                                placeholder={'INR'}
                                                fullWidth
                                            />
                                        </Box>

                                        {paymentType && (
                                            <Box sx={{ width: { xs: '100%' } }}>
                                                <ReusableComponent
                                                    type="text"
                                                    label="Commission"
                                                    value={commission}
                                                    onChange={setCommission}
                                                    placeholder={'e.g., 10 or 10%'}
                                                    fullWidth
                                                />
                                            </Box>
                                        )}
                                    </Box>

                                    <Box sx={{ flex: 1, width: '100%', pb: 3 }}>
                                        <ReusableDateInput
                                            label={"Deadline Date"}
                                            required={true}
                                            DeadLineDate={DeadLineDate}
                                            // setDeadLineDate={setDeadLineDate}
                                            setDeadLineDate={(val) => {
                                                setDeadLineDate(val);
                                                clearError("DeadLineDate");
                                            }}
                                            error={!!errors.DeadLineDate}
                                            helperText={errors.DeadLineDate}
                                            fullWidth
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        }
                    />
                    <Box pt={1}>
                        <ReusableCardView
                            title="Campaign Details"
                            Component={
                                <Box px={2} pt={2} pb={2}>
                                    <Grid container spacing={3}>
                                        {/* Dates Row */}
                                        <Grid item xs={12} sm={6}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Content Deadline Date *"
                                                    value={contentDeadlineDate}
                                                    // onChange={(newValue) => setContentDeadlineDate(newValue)}
                                                    onChange={(newValue) => {
                                                        setContentDeadlineDate(newValue);
                                                        clearError("contentDeadlineDate");
                                                    }}
                                                    renderInput={(params) => <TextField {...params} fullWidth size="small" error={!!errors.contentDeadlineDate}
                                                        helperText={errors.contentDeadlineDate} />}

                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Post Deadline Date *"
                                                    value={postDeadlineDate}
                                                    // onChange={(newValue) => setPostDeadlineDate(newValue)}
                                                    onChange={(newValue) => {
                                                        setPostDeadlineDate(newValue);
                                                        clearError("postDeadlineDate");
                                                    }}
                                                    renderInput={(params) => <TextField {...params} fullWidth size="small" error={!!errors.postDeadlineDate}
                                                        helperText={errors.postDeadlineDate} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <ReusableComponent
                                                type="numeric"
                                                label="Number of Revisions Allowed"
                                                value={revisionsAllowed}
                                                onChange={setRevisionsAllowed}
                                                placeholder={'e.g., 2'}
                                            />
                                        </Grid>

                                        {/* Location Workplace */}
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth size="small" error={!!errors.locationWorkplace}>
                                                <InputLabel>Location Workplace *</InputLabel>
                                                <Select
                                                    value={locationWorkplace}
                                                    label="Location Workplace *"
                                                    // onChange={(e) => setLocationWorkplace(e.target.value)}
                                                    onChange={(e) => {
                                                        setLocationWorkplace(e.target.value);
                                                        clearError("locationWorkplace");
                                                    }}
                                                >
                                                    {locationWorkplaceOptions.map(option => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {errors.locationWorkplace && (
                                                    <Typography variant="caption" color="error">
                                                        {errors.locationWorkplace}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Payment Terms</InputLabel>
                                                <Select
                                                    value={paymentTerms}
                                                    label="Payment Terms"
                                                    onChange={(e) => setPaymentTerms(e.target.value)}
                                                >
                                                    {paymentTermsOptions.map(option => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {/* Platforms */}
                                        <Grid item xs={12} sm={6}>
                                            <ReusableMultiComponent
                                                label={'Platforms'}
                                                options={platformOptions}
                                                selectedOptions={platforms}
                                                setSelectedOptions={setPlatforms}
                                                optionLabel="platformName"
                                            />
                                        </Grid>


                                        {/* Industry Category */}
                                        <Grid item xs={12} sm={6}>
                                            <ReusableMultiComponent
                                                label={'Industry Category'}
                                                options={industryCategoryOptions}
                                                selectedOptions={industryCategory}
                                                setSelectedOptions={setIndustryCategory}
                                                optionLabel="TypeName"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            }
                        />
                    </Box>
                    <Box sx={{ mt: 0, pt: 1 }}>
                        <ReusableCardView
                            title="Target Audience Demographics"
                            Component={
                                <Box px={2} pt={2} pb={2}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6}>
                                            <ReusableComponent
                                                type="numeric"
                                                label="Target Age Min"
                                                value={targetAgeMin}
                                                onChange={setTargetAgeMin}
                                                placeholder={'e.g., 18'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <ReusableComponent
                                                type="numeric"
                                                label="Target Age Max"
                                                value={targetAgeMax}
                                                onChange={setTargetAgeMax}
                                                placeholder={'e.g., 35'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Target Gender</InputLabel>
                                                <Select
                                                    value={targetGender}
                                                    label="Target Gender"
                                                    onChange={(e) => setTargetGender(e.target.value)}
                                                >
                                                    {targetGenderOptions.map(option => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <ReusableComponent
                                                type="text"
                                                label="Target Interests"
                                                value={targetInterests}
                                                onChange={setTargetInterests}
                                                placeholder={'e.g., Fashion, Technology'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <ReusableComponent
                                                type="text"
                                                label="Remark"
                                                value={remark}
                                                onChange={setRemark}
                                                placeholder={'e.g., get this now'}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            }
                        />
                    </Box>

                    <Box sx={{ mt: 0, pt: 1 }} >
                        <ReusableCardView
                            title="Requirement"
                            Component={
                                <Box px={2} pt={2} pb={2}>
                                    <RichTextEditor
                                        value={Requirements}
                                        // onChange={setRequirements}
                                        onChange={(val) => {
                                            setRequirements(val);
                                            clearError("Requirements");
                                        }}
                                        placeholder="Write something..."
                                        minHeight="140px"
                                        error={!!errors.Requirements}
                                        helperText={errors.Requirements}
                                    />
                                </Box>
                            }
                        />
                    </Box>
                </Grid>

                {/* FAQ */}
                <Grid item xs={12} md={6}>
                    <ReusableCardView
                        title="FAQ"
                        Component={
                            <Box p={2}>
                                <RichTextEditor
                                    value={FAQ}
                                    // onChange={setFAQ}
                                    onChange={(val) => {
                                        setFAQ(val);
                                        clearError("FAQ");
                                    }}
                                    placeholder="Write something..."
                                    minHeight="140px"
                                    error={!!errors.FAQ}
                                    helperText={errors.FAQ}
                                />
                            </Box>
                        }
                        disablepaddingBottom={true}
                    />
                </Grid>
            </Grid>

            <Box sx={{ marginBottom: '30px', marginTop: '20px' }}>
                {ButtonComponentGig()}
            </Box>

            <ConfirmationDialog
                open={confirmLeaveOpen}
                title="Leave without saving?"
                message="You have unsaved details in this gig. If you leave now, they will be lost."
                onClose={() => setConfirmLeaveOpen(false)}
                onConfirm={leaveWithoutSaving}
            />
        </Box>
    );
}